'use client';
import { useState, useEffect, useRef } from 'react';
import { Search } from 'lucide-react';

import { useCompassContext } from '@/src/libs/CompassContext';

const SearchBar: React.FC = () => {
  const [autocomplete, setAutocomplete] = useState<
    typeof google.maps.places.Autocomplete | null
  >(null);
  const ctx = useCompassContext()!;

  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!autocomplete) {
      if (!ctx.state.map || !inputRef.current) return;
      const newAutocomplete = new google.maps.places.Autocomplete(
        inputRef.current
      );
      newAutocomplete.addListener('place_changed', async () => {
        if (!ctx || !ctx.state.map) return;
        const place = newAutocomplete.getPlace();
        if (!place.geometry) return;

        const destination =
          place.geometry.viewport?.getCenter() ?? place.geometry.location;
        if (!destination) return;

        const center = {
          lat: destination.lat(),
          lng: destination.lng(),
        };

        if (place.geometry.viewport) {
          ctx.state.map.fitBounds(place.geometry.viewport);
        } else {
          ctx.state.map.panTo(center);
        }

        ctx.dispatch({
          type: 'ACCEPT_MAP_CENTER',
          payload: center,
        });
      });
      setAutocomplete(
        newAutocomplete as unknown as typeof google.maps.places.Autocomplete
      );
    }
  }, [ctx.state.map, autocomplete]);

  return (
    <div className="relative mb-8">
      <input
        className="w-full p-4 text-base placeholder-charcoal border-2 border-black rounded-[4px] focus:bg-blue focus:border-black focus:outline-none"
        placeholder="Search for a location..."
        ref={ctx?.state.map ? inputRef : null}
      />
      <Search
        aria-hidden="true"
        className="absolute top-1/2 right-4 transform -translate-y-1/2 pointer-events-none"
        size={16}
        strokeWidth={1.75}
      />
    </div>
  );
};

export default SearchBar;
